var _circle, _path, _path2, _rect, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg14Etc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5703,
    cy: 30.707,
    r: 10,
    fill: "#8F87F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5699 20.707C8.77036 20.707 7.08184 21.1824 5.62305 22.0143C8.0886 21.3344 14.1404 20.9352 18.6233 24.7778C16.8024 22.3087 13.8732 20.707 10.5699 20.707Z",
    fill: "#766EDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.570312 30.7063C0.570312 36.2292 5.04746 40.7063 10.5703 40.7063C12.4262 40.7063 14.164 40.2008 15.6535 39.3199C4.53959 38.7502 2.33826 29.2898 2.62683 24.6309C1.33685 26.3149 0.570312 28.4211 0.570312 30.7063Z",
    fill: "#4841A6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.99316,
    y: 0.507812,
    width: 18,
    height: 18,
    rx: 1,
    transform: "rotate(15 5.99316 0.507812)",
    fill: "#E7E6F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80859 4.92969L1.5937 16.9278C1.45076 17.4613 1.76734 18.0096 2.30081 18.1526L16.581 21.9789C8.54354 18.2968 5.38378 9.07853 4.80859 4.92969Z",
    fill: "#ABA9C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5703 40.7461H38.1561C39.047 40.7461 39.4932 39.669 38.8632 39.039L22.2774 22.4532C21.6475 21.8232 20.5703 22.2694 20.5703 23.1603V39.7461C20.5703 40.2984 21.018 40.7461 21.5703 40.7461Z",
    fill: "#4841A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5703 23.4941V39.7452C20.5703 40.2975 21.018 40.7452 21.5703 40.7452H29.6464C22.6331 37.202 20.6735 27.7682 20.5703 23.4941Z",
    fill: "#353071"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg14Etc);
export default __webpack_public_path__ + "static/media/14_etc.cc4e8ac78c6461b87aa23e0066a463eb.svg";
export { ForwardRef as ReactComponent };